"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgStreet(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "5 -4 14 24" }, props),
        React.createElement("path", { d: "M11 16H6.9a1.9 1.9 0 01-1.876-2.203l1.973-12.2A1.9 1.9 0 018.873 0H11v4h2V0h2.127c.931 0 1.726.677 1.875 1.597l1.973 12.2A1.901 1.901 0 0117.099 16H13v-4h-2zm0-5h2V5h-2z", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('Street')(SvgStreet);
//# sourceMappingURL=Street.js.map